<template>
  <div class="sysStoreEdit w-label">
    <form-header :page-title="`${id?'编辑':'新增'}系统大仓清单`" @save="submitForm"></form-header>
    <div class="content-area white-bg-radius">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="系统："
                      prop="system"
                      :rules="[{required: true, message: '此项为必填项'}]"
        >

          <el-select v-model="form.system" filterable
                     :readonly="!!id"
                     :disabled="!!id"
                     value-key="id"
                     placeholder="请选择"
                     @change="systemChange"
                     :clearable="true">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-option
              v-for="item in systems"
              :key="item.id"
              :label="item.code + ' ' + item.name"
              :value="item">
            </el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="达能大仓代号："
                      prop="wwOkuraCode"
                      :rules="[{required: true, message: '此项为必填项'}]"
        >
          <el-input v-model="form.wwOkuraCode" placeholder="请输入" :disabled="!!id" class="input">
            <span slot="prepend" v-if="!id">{{form.system && form.system.code}}</span>
            <span slot="append" v-if="!id">DC</span>
          </el-input>
        </el-form-item>
        <el-form-item label="达能大仓名称："
                      prop="wwOkuraName"
                      :rules="[{required: true, message: '此项为必填项'}]"
        >
          <el-input v-model="form.wwOkuraName" placeholder="请输入" class="input">
          </el-input>
        </el-form-item>
        <el-form-item label="系统大仓代号：" prop="sysOkuraCode" :rules="[{required: true, message: '此项为必填项'}]">
           <el-input v-model="form.sysOkuraCode"  class="input">
        </el-input>
        </el-form-item>
        <el-form-item label="系统大仓名称："  prop="sysOkuraName"  :rules="[{required: true, message: '此项为必填项'}]">
          <el-input v-model="form.sysOkuraName"  class="input">
        </el-input>
        </el-form-item>

        <el-form-item label="大仓所在地分公司："
                      prop="wwCodeWarehouseOkuraPlot"
                      :rules="[{required: true, message: '此项为必填项'}]"
        >
          <el-select v-model="form.wwCodeWarehouseOkuraPlot"
                     :filterable="true"
                     value-key="vkorg"
                     placeholder="请输入分公司名称或代号" :clearable="true">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>

            <el-option
              v-for="item in companies"
              :key="item.vkorg"
              :label="item.vkorg + ' ' + item.vremark"
              :value="item.vkorg">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" >
          <el-input v-model="form.remark" placeholder="请输入" class="input">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <searchDialog ref="dlg"></searchDialog>
  </div>
</template>

<script>
  import formHeader from '../components/form-header'
  import searchDialog from '../components/search-dialog'
  import { methodPost, methodGet } from '../../api/request'
  export default {
    components: {
      formHeader,
      searchDialog
    },
    data() {
      return {
        id: this.$route.query.id,
        form: {
          id: '',
          code: "",
          remark: "",
          sysId: "",
          sysOkuraCode: "",
          sysOkuraName: "",
          wwCodeWarehouseOkuraPlot: "",
          wwOkuraCode: "",
          wwOkuraName: ""
        },
        showHide: false,
        systems: [],
        customers: [],
        companies: []
      }
    },
    created() {
      const reqs = [];
      reqs.push(methodPost('/bill/findSysBillList', { "pageNo": 1, "pageSize": 10000 }))
      reqs.push(methodPost('/sysSapDataSaleOrg/findSysSapDataSaleOrgListNoPage', { "pageNo": 1, "pageSize": 10000 }));
      if (this.id) {
        reqs.push(methodGet(`/okurabill/findSysOkuraBillById/${this.id}`));
      }

      Promise.all(reqs).then(res => {
        if (res[0].code || res[1].code || (this.id && res[2].code)) {
          this.$message.error('网络异常，请稍后再试')
          return;
        }
        this.systems = res[0].data.data;
        this.companies = res[1].data;
        if (this.id) {
          const data = res[2].data
          console.log(this.systems)
          this.form = {
            id: data.sapCustomerCode,
            //  system: this.systems.find(o => o.id === data.sysId) || {},
            system: data.sysCode + ' ' + data.sysName,
            sysId: data.sysId,
            sysCode: data.sysCode,
            sysName: data.sysName,
            remark: data.remark,
            sysOkuraCode: data.sysOkuraCode,
            sysOkuraName: data.sysOkuraName,
            wwCodeWarehouseOkuraPlot: data.wwCodeWarehouseOkuraPlot,
            wwOkuraCode: data.wwOkuraCode,
            wwOkuraName: data.wwOkuraName
          }
        }
      })
    },
    methods: {
      systemChange() {

      },
      submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.form.sysId = this.form.system.id;
            this.form.sysCode = this.form.system.code;
            this.form.sysName = this.form.system.name;
            methodPost(`/okurabill/${this.id ? 'modifySysOkuraBill' : 'saveSysOkuraBill'}`, {
              ...this.form,
              id: this.id
            }).then(res => {
              // console.log(res);

              if (res.code !== 0) {
                this.$message.error(res.message || '保存出错，请稍后再试')
              } else {
                this.$message.success(`${this.id ? '修改' : '新增'}成功`)
                this._gobackRefresh(this, this.$route.fullPath, null, 'sys_okura_bill_list')
              }
            })
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style lang="scss" >

  .sysStoreEdit{
    // display: flex;
    // flex: 1;
    //padding: 0 0 0 20px;
    .el-form-item__error{
      left: 315px;
    }
    .content-area{
      // flex: 1;
      margin-top: 20px;
      padding-top: 20px;
      background: #fff;

      .input{
        width: 300px;
        white-space: nowrap;
      }
      .el-select {
        width: 300px;
      }
    }
  }
</style>

<style lang="scss">
  .clickable{
    cursor: pointer !important;
    .el-input__inner{
      cursor: pointer !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/sysWarehouse/index.vue